var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlameLevel5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.02 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0ba1e2;}.cls-2{fill:#dbdbdb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flame level 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.05,26C37.64,4.13,20.25,0,20.25,0c8.8,5.79,5.41,17.12.78,17.81-5.07.75-4-7-4-7-7.94,6.31,0,14.51-4.11,17.51s-6.19-1.93-6.19-1.93a21.55,21.55,0,0,0,3.54,19.8A15.45,15.45,0,0,0,22,51.8a24.67,24.67,0,0,0,4.11-.25c5.95-1,10.85-4.41,13.26-11.64,3-9-2-14.62-2-14.62C39.86,32.34,29.69,35.19,32.05,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.19,64H1.83a1.83,1.83,0,1,1,0-3.66H44.19a1.83,1.83,0,1,1,0,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.81,62.17c0-1,1.43-1.83,2.44-1.83H1.83a1.83,1.83,0,1,0,0,3.66H22.25C21.24,64,19.81,63.18,19.81,62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.7,60.34H18.29c1,0-.61.82-.61,1.83S19.3,64,18.29,64H31.7a1.83,1.83,0,0,0,0-3.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameLevel5);
export default __webpack_public_path__ + "static/media/Flame_level_5.90ef6eb691eabf8d1aee7183a7646c1a.svg";
export { ForwardRef as ReactComponent };